import { Command, CommandAction } from '@workbuddy/ui/model';
import type { SettingsPanelForm } from '../settings.panel/settings.panel.form';

export interface CommandPaletteScopeChip {
  label: string;
}

export interface CommandPaletteContext {
  id?: string;
  scopeChip?: CommandPaletteScopeChip;
  settingsPanel?: SettingsPanelForm;
}

export interface PaletteCommandConfig {
  settingsPanel?: unknown;
}

export type PaletteCommandData<TData extends Record<string, unknown> = Record<string, unknown>> = TData & {
  commandPalette?: PaletteCommandConfig;
};

export interface CreatePaletteCommandConfig<TData extends Record<string, unknown> = Record<string, unknown>> {
  id: string;
  label: string;
  tooltip?: string;
  iconLeft?: string;
  iconLeftColor?: string;
  iconRight?: string;
  iconRightColor?: string;
  disabled?: boolean;
  hidden?: boolean;
  count?: number;
  data?: TData;
  palette?: PaletteCommandConfig;
  action?: CommandAction;
}

export function createPaletteCommand<TData extends Record<string, unknown> = Record<string, unknown>>(config: CreatePaletteCommandConfig<TData>): Command {

  return new Command({
    _id: config.id,
    label: config.label,
    tooltip: config.tooltip,
    iconLeft: config.iconLeft,
    iconLeftColor: config.iconLeftColor,
    iconRight: config.iconRight,
    iconRightColor: config.iconRightColor,
    disabled: config.disabled,
    hidden: config.hidden,
    count: config.count,
    action: config.action,
    data: {
      ...config.data,
      commandPalette: config.palette,
    } satisfies PaletteCommandData<TData>,
  });
}
